import { Button, CharField, Flex, H1, SingleSelectField, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import type { FiltersBase } from "../../types"
import { useNavigate } from "react-router-dom"
import { useQsFilters } from "../../hooks/filters"
import { useNamedEntitiesList } from "../../hooks/named-entities"
import { TableNamedEntities } from "./TableNamedEntities"
import { NAMED_ENTITY_TYPES } from "../../constants"

const initFilters = (params: URLSearchParams) =>
  ({
    page: Number(params.get("page") ?? 1),
    search: params.get("search") ?? "",
    ordering: params.get("ordering") ?? "name",
    entity_type: params.get("entity_type") ?? "",
  } as FiltersBase & { entity_type: string })

export default function NamedEntities() {
  const { filters, uiFilters, setFilters } = useQsFilters(initFilters)

  const { data } = useNamedEntitiesList({
    page: String(filters.page),
    search: filters.search,
    ordering: filters.ordering,
    entity_type: filters.entity_type,
  })

  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Entità" }])

  return (
    <Layout>
      <Flex direction="column" justifyContent="start" alignItems="stretch" className="w-100 h-100">
        <Flex alignItems="center" justifyContent="between" className="mb-5">
          <H1>Entità</H1>
          <Button
            size="md"
            className="text-white"
            title="Aggiungi"
            leadingIcon="add"
            onClick={() => {
              navigate("/named-entities/named-entities/new")
            }}
          />
        </Flex>
        <Flex className="mb-3" style={{ gap: 3, zIndex: 1000 }}>
          <CharField
            label=""
            placeholder="Cerca..."
            leadingIcon="search"
            style={{
              width: 300,
            }}
            value={filters.search}
            onChange={(value) => {
              setFilters({ ...filters, search: value , page: 1 })
            }}
          />
          <SingleSelectField
            label=""
            placeholder="Tipo di entità"
            style={{ width: 300, marginLeft: 16, zIndex: 2 }}
            value={
              NAMED_ENTITY_TYPES.find((type) => type.value === filters.entity_type) || null
            }
            options={
              [{ label: "Tutti", value: "" }, ...NAMED_ENTITY_TYPES]
            }
            onChange={(value) => {
              setFilters({ ...filters, entity_type: value?.value || "", page: 1 })
            }}
          />
        </Flex>
        <TableNamedEntities
          namedEntities={data?.results || []}
          setFilters={setFilters}
          filters={uiFilters}
          count={data?.count || 0}
          fullCount={data?.full_count || 0}
        />
      </Flex>
    </Layout>
  )
}
